import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { EmployeePaymentProfile } from 'src/app/store/main/models/main.models';

@Injectable({ providedIn: 'root' })
export class EmployeePaymentProfileService {

    resourceUrl: string = environment.apiEndpoint;

    constructor(private http: HttpClient) {
    }


    getEmployeePaymentProfile(organizationId: string, employeeId: number, mergePayRateConfigurations: boolean): Observable<EmployeePaymentProfile> {
        let url = `${this.resourceUrl}/organizations/${organizationId}/payment/payment-profiles/${employeeId}`
        if (mergePayRateConfigurations) {
            url += '?mergePayRateConfigurations=true'
        }
        return this.http.get<EmployeePaymentProfile>(url);
    }

    upsertEmployeePaymentProfile(organizationId: string, employeePaymentProfile: EmployeePaymentProfile): Observable<EmployeePaymentProfile> {
        const url = `${this.resourceUrl}/organizations/${organizationId}/payment/payment-profiles/${employeePaymentProfile.employeeId}`;
        return this.http.post<EmployeePaymentProfile>(url, employeePaymentProfile);
    }


}